import { clearDB, setApplicationSetup } from '@/repo/appSettingRepo';
import chroma from 'chroma-js';
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import config from '../config/app';
import { postAPICall } from '../helpers/httpHelper';
import { fetchEntityById } from '../repo/entityRepo';
import { getAllFieldsArrayFromEntity } from '../utils/formatter';
import permissionsHelper from './permissionsHelper';
export default {
  name: 'authHelper',
  components: {
    permissionsHelper,
  },
  data() {
    return {
      currentWorkspace: {},
      entityRecordsForTableLocal: null,
      currentWorkspaceId: '',
      userWorkspaceList: [],
      brandingInfo: {},
      globalFilterLoading: false,
      globalFilterLimit: 30,
      globalFilterPage: 1,
      globalFilterSearch: '',
      globalFilterEntity: null,
      isSearching: false,
      globalFilterHasMoreData: false,
      allGlobalFilterEntityData: [],
      activeRole: '',
    };
  },
  computed: {
    ...mapGetters('auth', [
      'getAuthenticatedUser',
      'getActiveWorkspace',
      'getAuthenticationStatus',
      'getWorkspaceList',
      'getGlobalFiltervalue',
      'getUserTypeEmails',
      'getAppMode',
    ]),
    ...mapGetters('company', [
      'getCompanyDetails',
      'getUpdateCompany',
      'getCompanyLogo',
      'getSingleCompanyLogo',
      'getContactLoginSlug',
      'getIsMobile',
    ]),
    // ...mapGetters("entities", ["getEntityRecordsForTable"]),
    globalFilterExists() {
      if (this.getCompanyDetails?.global_filters) {
        let gFilter = this.getCompanyDetails.global_filters.find((e) => e.include_in_topbar);
        return gFilter?.field_type ? gFilter : null;
      }
      return null;
    },
    isSSOUser() {
      return this.getAuthenticatedUser && this.getAuthenticatedUser.sso_user_id;
    },
  },
  methods: {
    async changeWorkspace(newWorkspaceId, isNotFromTopBar = false) {
      try {
        Swal.close();
        Swal.fire({
          title: 'Are you sure?',
          text: 'Are you sure to switch the workspace?',
          icon: 'warning',
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          confirmButtonColor: 'var(--brand-500)',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.$bus.$emit('load-component', true, 'Switching workspace');
            await this.$store.dispatch('auth/switchWorkspace', {
              currentWorkspaceId: newWorkspaceId,
            });

            if (this.getAuthenticationStatus) {
              this.$store.commit('errors/reset', null, { root: true });
              this.currentWorkspace = this.getAuthenticatedUser.current_workspace;

              this.$store.commit('auth/setActiveWorkspace', this.currentWorkspace, { root: true });

              await clearDB();

              let promises = [
                this.fetchUserDataAfterSwitch(),
                this.getCompanyInfo(true),
                this.$store.dispatch('auth/fetchProfile'),
              ];

              if (this.getAppMode) {
                promises.push(setApplicationSetup());
                this.$store.commit('auth/setAppMode', true, { root: true });
              }

              await Promise.all(promises);

              if (this.isWorkspaceIsBusiness) {
                await this.getCompanyUserType(this.getAuthenticatedUser.activeRole.userType_id);
              }

              // ✅ Check MFA before redirecting
              const requiresMFA = await this.fetchMFASettings();
              if (requiresMFA) {
                Swal.close();
                return; // stop here, since we redirected to /mfa
              }

              // ✅ If no MFA, proceed to dashboard
              let path = '/dashboard?route=';
              await this.$router.push({
                path: `${path}${Math.floor(Math.random() * (1000 - 1)) + 100}&from_login=true`,
              });
              window.location.reload();
              Swal.close();
            }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            if (!isNotFromTopBar) {
              await this.$router.push({
                path: `/apps?route=${Math.floor(Math.random() * (1000 - 1)) + 100}`,
              });
              await this.$store.dispatch(
                'auth/fetchUsersWithEmail',
                this.getAuthenticatedUser.email
              );
            }
            this.currentWorkspaceId = this.currentWorkspace.company_id;
            this.setActiveRole();
          }
        });
      } catch (err) {
        this.$bus.$emit('load-component', false, '');
        console.log('changeWorkspace', err);
      }
    },

    async getCompanyUserType(activeRole) {
      try {
        await this.$store.dispatch('auth/getUserTypeById', activeRole || this.activeRole);
      } catch (err) {
        console.log('getCompanyUserType', err);
        this.$notify.error({
          title: 'Error',
          message: err,
        });
      }
    },
    setActiveRole() {
      this.activeRole = this.getAuthenticatedUser?.activeRole?.userType_id || '';
    },
    async fetchUserDataAfterSwitch() {
      // this.loading = true;
      await this.$store.dispatch('auth/fetchUsersWithEmail', this.getAuthenticatedUser.email);
      if (this.getWorkspaceList) {
        let info = await this.updateIndividualWorkspace(this.getActiveWorkspace);
        this.currentWorkspace = info.currentWorkspace;
        this.userWorkspaceList = info.userWorkspaceList;
      } else {
        this.userWorkspaceList = [];
      }
    },
    async getCompanyInfo(fetchNewData) {
      // this.loading = true;
      try {
        if (fetchNewData) {
          await Promise.all([
            this.$store.dispatch('company/fetchCompany', this.getActiveWorkspace.company_id),
            this.$store.dispatch('company/fetchCompanyLogo', this.getActiveWorkspace.company_id),
          ]);
        }
        await this.$store.dispatch('theme/fetchThemes');
        if (this.getCompanyDetails) {
          this.brandingInfo = {
            ...this.getCompanyDetails,
          };
          await Promise.all([this.applyTheme(), this.fetchGlobalFilterEntityData()]);
        }
      } catch (e) {
        this.$bus.$emit('load-component', { value: false });
        this.$notify.error({
          title: 'Error',
          message: e,
        });
      }
    },
    async applyTheme() {
      // Apply theme using company info
      // Ensure that this.companyInfo is set before applying theme
      document.documentElement.style.setProperty(
        '--primary-color',
        this.getCompanyDetails.dialog_header_color
      );
      document.documentElement.style.setProperty(
        '--icon-color',
        this.getCompanyDetails.menu_icon_color
      );
      document.documentElement.style.setProperty(
        '--icon-hover-color',
        this.getCompanyDetails.menu_icon_hover_color
      );
      document.documentElement.style.setProperty('--tabs-color', this.getCompanyDetails.tabs_color);
      document.documentElement.style.setProperty(
        '--tabs-hover-color',
        this.getCompanyDetails.tabs_hover_color
      );
      document.documentElement.style.setProperty(
        '--application-background-color',
        this.getCompanyDetails.application_background_color
      );
      document.documentElement.style.setProperty(
        '--primary-contrast-color',
        this.getCompanyDetails.dialog_header_text_color
      );
      document.documentElement.style.setProperty(
        '--sidemenu-background-color',
        this.getCompanyDetails.sidemenu_background
      );
      document.documentElement.style.setProperty(
        '--sidemenu-text-color',
        this.getCompanyDetails.sidemenu_text
      );
      document.documentElement.style.setProperty(
        '--topbar-text-color',
        this.getCompanyDetails.topbar_text_color
      );
      const primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--primary-color')
        .trim();
      const lighterPrimaryColor = chroma(primaryColor).brighten(0.5).hex();
      const lighterbackgroundColor = chroma(primaryColor).brighten(1.0).hex();
      const darkerPrimaryColor = chroma(primaryColor).darken(0.5).hex();
      document.documentElement.style.setProperty('--darker-primary-color', darkerPrimaryColor);
      document.documentElement.style.setProperty('--lighter-primary-color', lighterPrimaryColor);
      document.documentElement.style.setProperty('--lighter-background', lighterbackgroundColor);
      // document.documentElement.style.setProperty('--Hover-color-inputfield', this.companyInfo.menubackground);
      // document.documentElement.style.setProperty('--text-secondary-color', 'white');

      const secondaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--secondary-color')
        .trim();

      const darkerSecondaryColor = chroma(secondaryColor).brighten(0.3).hex();

      document.documentElement.style.setProperty('--darker-secondary-color', darkerSecondaryColor);

      if (this.getCompanyDetails.default_font_type) {
        document.documentElement.style.setProperty(
          '--font-family',
          this.getCompanyDetails.default_font_type
        );
      }

      /*** Based On company Profile setting, Top bar color will apply - Block Start */
      if (this.getCompanyDetails?.menubackground) {
        this.loginPageColor = this.getCompanyDetails.menubackground;
      } else {
        this.loginPageColor = '#1B487E';
      }
      /*** Based On company Profile setting, Top bar color will apply - Block end */
    },
    async fetchGlobalFilterEntityData() {
      if (this.globalFilterExists?.entity_id) {
        this.globalFilterLoading = true;
        this.globalFilterEntity = await fetchEntityById(this.globalFilterExists.entity_id);
        let params = {
          entity_id: this.globalFilterExists.entity_id,
          template_fields_data: getAllFieldsArrayFromEntity(this.globalFilterEntity),
          format_data: true,
          filters: [],
          relationship: {},
          limit: this.globalFilterLimit,
          page: this.globalFilterPage,
        };
        if (this.globalFilterSearch) {
          params.search_string = this.globalFilterSearch;
          params.primary_search_fields = this.getSearchPrimaryFields(0);
        }

        const v2Response = await postAPICall('POST', '/entities-data/entity/data/v2', params);
        this.entityRecordsForTableLocal = v2Response?.data;
        if (this.isSearching || !this.loadMore) {
          this.allGlobalFilterEntityData = [];
        }
        this.loadMore = false;
        if (this.entityRecordsForTableLocal) {
          this.globalFilterHasMoreData = this.entityRecordsForTableLocal.hasMore;
          this.allGlobalFilterEntityData = [
            ...(this.allGlobalFilterEntityData || []),
            ...this.entityRecordsForTableLocal.data,
          ];
          if (this.getGlobalFiltervalue) {
            this.globalFilter = this.getGlobalFiltervalue;
          }
          if (this.globalFilter) {
            let existed = this.allGlobalFilterEntityData.find((e) => e._id == this.globalFilter);
            if (!existed) {
              this.globalFilter = '';
              this.$store.commit('auth/setGlobalFiltervalue', '', {
                root: true,
              });
            }
          }
        }
        this.globalFilterLoading = false;
      }
    },
    getSearchPrimaryFields(index) {
      let result = [];
      if (
        this.globalFilterEntity?.primaryFields?.[index]?.template_id &&
        this.globalFilterEntity?.primaryFields?.[index]?.key
      ) {
        const baseKey = [
          this.globalFilterEntity?.primaryFields?.[index]?.template_id +
            '#' +
            this.globalFilterEntity?.primaryFields?.[index]?.key,
        ];
        result = [baseKey];
        const suffixMap = {
          ENTITY: '/name',
          INTEGRATION: '/name',
          PHONE_COUNTRY_CODE: '_code',
          MASKED: '_masked',
        };
        const suffix = suffixMap[this.globalFilterEntity?.primaryFields?.[index]?.inputType];
        if (suffix) {
          result.push(baseKey + suffix);
        }
      }
      return result;
    },
    async changeWorkspaceRole(newWorkspaceId, activeRole) {
      this.$bus.$emit('load-component', false);
      Swal.close();
      Swal.fire({
        title: 'Are you sure?',
        text: 'Are you sure to switch the Role?',
        icon: 'warning',
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonColor: 'var(--brand-500)',
        cancelButtonColor: '#fff',
        confirmButtonText: 'Yes',
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$bus.$emit('load-component', true);
          await this.$store.dispatch('auth/switchWorkspace', {
            currentWorkspaceId: newWorkspaceId,
            activeRole: activeRole,
          });
          if (this.getAuthenticationStatus) {
            this.$store.commit('errors/reset', null, {
              root: true,
            });
            this.currentWorkspace = this.getAuthenticatedUser.current_workspace;
            this.$store.commit('auth/setActiveWorkspace', this.currentWorkspace, {
              root: true,
            });
            await Promise.all([
              this.fetchUserDataAfterSwitch(),
              this.getCompanyInfo(true),
              this.$store.dispatch('auth/fetchProfile'),
            ]);
            if (this.isWorkspaceIsBusiness) {
              await this.getCompanyUserType();
            }
            await this.$router.push({
              path: `/dashboard?route=${Math.floor(Math.random() * (1000 - 1)) + 100}`,
            });
            window.location.reload();
            Swal.close();
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.currentWorkspaceId = this.currentWorkspace.company_id;
          this.setActiveRole();
        }
      });
    },
    getStyleForHorMenu() {
      if (
        this.getCompanyDetails &&
        this.getCompanyDetails.menuType &&
        this.getCompanyDetails.menuType == 'Horizontal'
      ) {
        this.isHorMenu = false;
        document.getElementById('MainLayout').style.marginTop = '80px';
        document.getElementById('MainLayout').style.paddingTop = '80px';
        document.getElementById('MainLayout').style.paddingLeft = '30px';
        document.getElementById('MainLayout').style.paddingRight = '10px';
        return (document.getElementById('topBarHeader').style.position = 'fixed');
      } else if (this.getIsMobile) {
        document.getElementById('MainLayout').style.marginTop = '140px';
        document.getElementById('MainLayout').style.paddingTop = '80px';
        document.getElementById('MainLayout').style.paddingLeft = '30px';
        document.getElementById('MainLayout').style.paddingRight = '10px';
        return (document.getElementById('topBarHeader').style.position = 'fixed');
      } else {
        // return '';
        document.getElementById('MainLayout').style.marginTop = '55px';
        document.getElementById('MainLayout').style.paddingTop = '0.75rem';
        document.getElementById('MainLayout').style.paddingLeft = '0';
        document.getElementById('MainLayout').style.paddingRight = '0';
        document.getElementById('MainLayout').style.marginInline = '0.75rem';

        return (document.getElementById('topBarHeader').style.position = 'fixed');
      }
    },
    async getSubscriptionHistory() {
      try {
        if (Object.keys(this.getPaymentsHistory)?.length) {
          return;
        }
        let email = 'info@esigns.io';
        await this.$store.dispatch('paymentGateway/fetchSubscriptionInfo', {
          email,
        });
      } catch (error) {
        console.log('getSubscriptionHistory', error);
      }
    },
    async handleLogoutInfo() {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: "Due to inactivity for a prolonged period, your session has been automatically logged out for security purposes. Please feel free to log in again when you're ready!",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          let timerInterval;
          Swal.fire({
            title: '',
            html: 'Please wait ..... ',
            timer: 2000,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
              Swal.showLoading();
            },
            willClose: () => {
              clearInterval(timerInterval);
              this.logout();
            },
          });
        }
      });
    },
    async getUserTypeEmailsList(userTypes) {
      try {
        if (!userTypes.length) {
          return [];
        }
        let AllUserTypeIds = userTypes.map((e) => e._id);
        let params = {
          userTypes: AllUserTypeIds,
        };
        await this.$store.dispatch('auth/fetchUserTypeEmails', params);
        if (this.getUserTypeEmails) {
          return this.getUserTypeEmails.data;
        }
      } catch (err) {
        this.$notify.error({
          title: 'Error',
          message: this.getUserTypeEmailsErrors,
        });
      }
    },
    logout() {
      localStorage.removeItem('botId');
      localStorage.removeItem('internal_chat_enabled');

      localStorage.removeItem('token');
      window.bus.$emit('chatbot');
      let timerInterval;
      Swal.fire({
        title: '',
        html: 'E-Signs signing off....',
        timer: 3000,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
          // Reset theme BEFORE clearing localStorage
          this.$store.dispatch('theme/resetTheme', null, { root: true });
          localStorage.removeItem(config.APP_NAME + '_' + config.APP_VERSION);
          localStorage.clear();
          if (this.isSSOUser) {
            window.location.href =
              this.serverBaseURL + '/logout/client?redirect_url=' + this.baseURL;
            return;
          } else {
            this.resetStore();
          }
        },
        willClose: () => {
          clearInterval(timerInterval);
          this.resetStore();
          if (this.isSSOUser) {
            window.location.href =
              this.serverBaseURL + '/logout/client?redirect_url=' + this.baseURL;
            return;
          }
          clearDB(true);
          this.$router.push({
            path: '/signin',
          });
        },
        backdrop: `rgba(0,0,0,0.7) left top no-repeat `,
        customClass: {
          popup: 'logout-popup',
        },
      });
    },
    resetStore() {
      this.$store.commit('auth/resetAuthData', null, {
        root: true,
      });
      this.$store.commit('sso/resetAuthData', null, {
        root: true,
      });
      this.$store.commit('entityGroups/resetData', null, {
        root: true,
      });
      this.$store.commit('menuManagementV2/resetData', null, {
        root: true,
      });
      this.$store.commit('menuManagement/resetData', null, {
        root: true,
      });
      this.$store.commit('globalVariables/resetData', null, {
        root: true,
      });
      this.$store.commit('repeatableTemplates/resetData', null, {
        root: true,
      });
      this.$store.commit('templatesData/resetData', null, {
        root: true,
      });
      this.$store.commit('entities/resetData', null, {
        root: true,
      });
      this.$store.commit('companyTemplates/resetData', null, {
        root: true,
      });
      this.$store.commit('templateWorkflow/resetData', null, {
        root: true,
      });
      this.$store.commit('company/resetData', null, {
        root: true,
      });
      this.$store.commit('userStatus/resetData', null, {
        root: true,
      });
      this.$store.commit('subscription/resetData', null, {
        root: true,
      });
      this.$store.commit('templates/resetData', null, {
        root: true,
      });
      this.$store.commit('settings/resetData', null, {
        root: true,
      });
      // Reset theme state and CSS variables
      this.$store.dispatch('theme/resetTheme', null, {
        root: true,
      });
      this.$store.commit('dashboard/resetData', null, {
        root: true,
      });
      this.$store.commit('contactTypes/resetData', null, {
        root: true,
      });
      this.$store.commit('documentNotes/resetData', null, {
        root: true,
      });
      this.$store.commit('configurableDocuments/resetData', null, {
        root: true,
      });
      this.$store.commit('contacts/resetData', null, {
        root: true,
      });
      this.$store.commit('s3FileUpload/resetData', null, {
        root: true,
      });
      this.$store.commit('documents/resetData', null, {
        root: true,
      });
      this.$store.commit('errors/resetData', null, {
        root: true,
      });
      this.$store.commit('fileUpload/resetData', null, {
        root: true,
      });
      this.$store.commit('errors/reset', null, {
        root: true,
      });

      this.$store.commit('employeeData/reset', null, {
        root: true,
      });
      this.$store.commit('employeeDocuments/reset', null, {
        root: true,
      });
      this.$store.commit('userIntegrations/resetData', null, {
        root: true,
      });

      this.$store.commit('paymentGateway/resetData', null, {
        root: true,
      });

      this.$store.commit('theme/resetData', null, {
        root: true,
      });

      this.$store.commit('theme/resetData', null, {
        root: true,
      });

      this.$store.commit('icons/resetData', null, {
        root: true,
      });
      clearDB(true);
    },
    async fetchMFASettings() {
      try {
        const user = this.getAuthenticatedUser || {};
        const companyId = user?.current_workspace?.company_id;
        const wsUserTypeId = user?.current_workspace?.user_type;
        const userMfa = !!user?.mf2a;

        await Promise.all([
          this.$store.dispatch('company/fetchCompany', companyId),
          this.$store.dispatch('company/fetchCompanyLogo', companyId),
        ]);

        const roles = Array.isArray(user?.roles) ? user.roles : [];
        const activeRole = user?.activeRole;
        let roleIdForWS = null;

        if (activeRole?.userType_id === wsUserTypeId) {
          roleIdForWS = activeRole.role_id;
        } else {
          roleIdForWS = roles.find((r) => r.userType_id === wsUserTypeId)?.role_id || null;
        }

        const mfa = this.getContactLoginSlug?.mfa_settings || {};
        const enabled = !!mfa.enabled;
        const configuredRoleIds = Array.isArray(mfa.role_ids) ? [...mfa.role_ids] : [];

        const otpByCompany =
          enabled &&
          (configuredRoleIds.length === 0 ||
            (roleIdForWS && configuredRoleIds.includes(roleIdForWS)) ||
            (wsUserTypeId && configuredRoleIds.includes(wsUserTypeId)));

        const requiresMFA = otpByCompany || userMfa;

        if (requiresMFA && this.$route?.path !== '/mfa') {
          await this.$router.push({ path: '/mfa' });
        }
        return requiresMFA;
      } catch (err) {
        console.error('Error fetching MFA settings:', err);
        return false;
      }
    },
  },
};
